/**
 * @file   src\Pages\Notifications.tsx
 * @brief  Notifications page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, Link , useState, useParams , useEffect} from "../utils/thirdpartyComponents";
import CWFooter from "src/components/CWFooter";
import Gobackicon from "../assets/images/left-arrow-small.svg";
import Promoicon from "../assets/images/promotions-icon.svg";
import Paymenticon from "../assets/images/payment-icon.svg";
import Locationicon from "../assets/images/locations-icon.svg";
import "src/styles/inner-page-styles.scss";
import { pageURLs } from "src/utils/pageUrls";
import { UserApi} from "../utils/apiUrls";
import { MessageToaster } from 'src/utils/toastUtil';
import axios from '../config/axiosConfig';
import SmallLoader from '../components/SmallLoader';
import { NotificationArray } from '../interfaces/generalInterface';
import InfiniteScroll from "react-infinite-scroll-component";

const Notifications = () => {
   // Instantiate Message
   const toaster = new MessageToaster();
    
    const params = useParams();
    const [loading, setLoading] = useState(false);
    const [notifications, setNotificationList] = useState<NotificationArray[]>([]);
    const [hasMore, setHasMore] = useState(true);
    const [pageNumber, setPageNumber] = useState(1);
    const fetchedPages:number[] = [];

  //1- Payment, 2 - Promotions, 3- Location related(Location activate deactivate), 4- Other
    const getIcon = (type: number) => {
        switch (type) {
            case 1:
            return Paymenticon;
            case 2:
            return Promoicon;
            case 3:
            return Locationicon;
            default:
            return Promoicon;
        }
    };

    useEffect(() => {
      fetchUserNotifications(pageNumber);
    }, []);


    const fetchUserNotifications = async (page : number) => {
      if(!fetchedPages.includes(page)) {
        
        try {
            setLoading(true); // Show loader
            fetchedPages.push(page)
            const responseData = await axios.get(UserApi.NOTIFICATION_LIST+'?pageNo='+page);
        
            if (responseData?.data?.error === 0) {
              setPageNumber((prevPageNumber) => prevPageNumber + 1)
              if(responseData.data.data.list.length) {
                setNotificationList((notifications) => [...notifications, ...responseData.data.data.list]);
              }
              if(responseData.data.data.list.length < responseData.data.data.totalCount) {
                (responseData.data.data.list.length > 0 || responseData.data.data.list.length === responseData.data.data) ? setHasMore(true) : setHasMore(false);
              } else {
                setHasMore(false)
              }
            
            } else {
              toaster.toastError(responseData?.data?.message);
              setHasMore(false)
            }
          } catch (error: any) {
            throw new Error(error.response?.data?.message || error.message);
          } finally {
              setLoading(false); // Hide loader
          }
      } else {
        setHasMore(false)
      }
    };

    
    

return (
   
  <div className="common-content-wrap pb-170"> 
    <div className="inner-content-wrap">
        <div className="common-header two-block-header">
            <div className="pe-4 ps-4 pt-0 pb-0 h-100">
                <div className="common-header-inner">
                <Link to={"/"+params.carwashname+"/"+pageURLs.settings} className="back-link"><img src={Gobackicon} alt="Car Wash App" /></Link> Notifications
                </div>
            </div>
        </div>
        <div className="main-content-wrap pe-0 ps-0 pt-0">
            
           {notifications && notifications.length ? <InfiniteScroll
              dataLength={notifications.length}
              next={() => fetchUserNotifications(pageNumber)}
              hasMore={hasMore}
              loader={null}
              pullDownToRefreshContent={
                <h3 style={{ textAlign: 'center' }}>&#8595; Pull down to refresh</h3>
              }
              releaseToRefreshContent={
                <h3 style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
              }
            >
              <div className="notifications-wrap d-flex flex-column">
                {notifications && notifications.length ? notifications.map((notification, index) => (
                    <div key={index} className="notify-card d-flex">
                        <div className="noty-icon"><img src={getIcon(notification.Type)} alt="Car Wash App" /></div>
                        <div className="noty-content">
                            <h6>{notification.Title}</h6>
                            <p>{notification.Notification}</p>
                        </div>
                    </div>
                )) : ''}
                </div>
                </InfiniteScroll>
              : <div className="notifications-wrap d-flex flex-column" style={{ textAlign: 'center' }}>No data found</div>}           
        </div>
    </div>
    {loading && <SmallLoader />}
    <CWFooter activeLink="Notifications"/>
  </div>  
)
}

export default Notifications;
